<template>
	<form @submit.prevent="send" :action="action" :method="method || 'post'">
		<slot :object="object" :form="form" :errors="errors" :loading="loading"></slot>
	</form>
</template>

<script>
	export default {
		props: ['action', 'method', 'formData', 'objectData', 'unsaveable', 'objectKey', 'upload'],
		data() {
			return {
				loadCount: 0,
				object: {},
				form: {},
				errors: {}
			};
		},
		computed: {
			loading() {
				return this.loadCount > 0;
			}
		},
		watch: {
			loadCount() {
				this.$emit('loading', this.loading);
			},
			formData: {
				async handler() {
					if(typeof(this.formData) === 'string') {
						this.loadCount++;
						try {
							this.form = await this.$get(this.formData);
						} catch(e) {
							this.form = {};
						}
						this.loadCount--;
						return;
					}
					this.form = (this.formData)?this.formData:{};
				},
				immediate: true
			},
			objectData: {
				async handler() {
					if(typeof(this.objectData) === 'string') {
						this.loadCount++;
						try {
							this.object = await this.$get(this.objectData);
						} catch(e) {
							this.object = {};
						}
						this.loadCount--;
						this.$emit('loaded', this.object);
						return;
					}
					this.object = (this.objectData)?this.objectData:{};
				},
				immediate: true
			}
		},
		methods: {
			async save(event) {
				if(this.unsaveable) {
					return;
				}
				if (event.keyCode === 83 && event.ctrlKey) {
			        event.preventDefault();
			    	await this.send();
			    }  
			},
			async send() {
				if(this.loading) {
					return;
				}
				this.loadCount++;
				this.errors = {};
				try {
					let method = this.method || 'post';
					let headers = {};
					if(this.upload) {
						method = 'upload';
						headers = this.method || 'post';
					}	
					const data = await this['$' + method](this.action, this.object, headers);
					let object = data[this.objectKey || 'model'];
					if(object) {
						this.object = object;
					} else {
						this.object = {};
					}
					this.$emit('submit', this.object);
				} catch(e) {
					if(e.data){
						this.errors = e.data;
					}
				}
				this.loadCount--;
			},
			set(key, value) {
				this.object[key] = value;
			}
		},
		mounted() {
			document.addEventListener('keydown', this.save);
		},
		beforeDestroy() {
			document.removeEventListener('keydown', this.save);
		}
	}
</script>